<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">Contact Us</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">Contact Us</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="contact-info-area pt-35 pb-85">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <div class="contact-info-item text-center mt-30">
                            <i class="ion ion-md-map"></i>
                            <h6 class="title">Address</h6>
                            <p>82 Valley Farms Court</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <div class="contact-info-item text-center mt-30">
                            <i class="ion ion-md-call"></i>
                            <h6 class="title">Phone Number</h6>
                            <p>(546) 347-9636</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <div class="contact-info-item text-center mt-30">
                            <i class="ion ion-md-mail"></i>
                            <h6 class="title">Email</h6>
                            <p>sswstudio@gmail.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="contact-touch-area pt-85 pb-90 bg-white">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-3">
                        <div class="contact-touch-thumb d-none d-lg-block">
                            <img src="/images/contact-touch-thumb.jpg" alt="contact">
                        </div>
                    </div>
                    <div class="col-lg-9">
                        <div class="contact-touch-part">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="secton-title text-center">
                                        <h5 class="title">Get in touch</h5>
                                        <p>Lorem Ipsum is not simply random text. </p>
                                    </div>
                                </div>
                            </div>
                            <form id="contact-form" @submit.prevent="sendMessage">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <input v-model="form.name" name="name" type="text" placeholder="Your name">
                                            <small style="color: red" v-if="error && errors.name">{{
                                                errors.name[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <input v-model="form.email" name="email" type="email"
                                                   placeholder="Your Email">
                                            <small style="color: red" v-if="error && errors.email">{{
                                                errors.email[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="input-box mt-35">
                                            <textarea v-model="form.message" name="message" id="#mes" cols="30"
                                                      rows="10"
                                                      placeholder="Message"
                                                      style="border: 1px solid #dcd9d9;"></textarea>
                                            <small style="color: red" v-if="error && errors.message">{{
                                                errors.message[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="input-box mt-35 text-center">
                                            <button type="submit">Send</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <p class="form-message"></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="vld-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="true"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        name: "ContactUs",
        components: {
            Loading
        },
        data() {
            return {
                isLoading: false,
                error: false,
                errors: {},
                form: {
                    name: '',
                    email: '',
                    message: ''
                }
            }
        },
        methods: {
            sendMessage() {
                this.isLoading = true;
                this.axios.post('contact', this.form).then(() => {
                    this.isLoading = false;
                    this.form = {
                        name: '',
                        email: '',
                        message: ''
                    }
                    this.$swal({
                        icon: 'success',
                        title: 'Message sent!',
                        text: 'We have received your message. We will get back to you. Thanks'
                    })
                }).catch(resp => {
                    this.isLoading = false;
                    this.error = true;
                    this.errors = resp.response.data.errors;
                })
            }
        }
    }
</script>

<style scoped>

</style>